import { Col, Row, Stack } from 'react-bootstrap';
import React, { useState } from 'react';
import { Button, useWizardContext } from '@odmonorepo/core-components';
import { steps } from 'merchant-components';
import { useFormContext } from 'react-hook-form';

interface NavigationProps {
  validate?: boolean;
  submit?: boolean;
  disabled?: boolean;
  continueText?: React.ReactNode;
  continueOnly?: boolean;
  customBackBtn?: React.ReactNode;
  handleNext?: () => any | Promise<any>;
  isLoading?: boolean;
  /** Renders full-width Continue over Back in a vertical stack, for use inside a Card (OwnerReview layout). */
  stacked?: boolean;
}

export const Navigation = ({
  validate = true,
  submit,
  disabled = false,
  continueText,
  continueOnly = false,
  handleNext,
  className,
  customBackBtn,
  style,
  isLoading,
  stacked = false
}: NavigationProps & React.HTMLAttributes<HTMLDivElement>) => {
  const [loading, setLoading] = useState(false);
  const { previousStep, nextStep, isFirstStep } = useWizardContext<typeof steps>();
  const form = useFormContext();
  const isButtonDisabled = disabled || loading || !!isLoading;

  const handleValidate = async () => {
    if (!validate) return handleNext ? Promise.resolve(handleNext()).then(v => v === true) : true;
    const isValid = await form.trigger();
    !isValid && window.scrollTo({ top: 0, behavior: 'smooth' });
    return isValid ? (handleNext ? Promise.resolve(handleNext()).then(v => v === true) : true) : false;
  }
  const handleClick = async () => {
    if (isButtonDisabled) return;
    setLoading(true);
    try {
      const valid = await handleValidate();
      valid && nextStep();
    } finally {
      setLoading(false);
    }
  };

  if (stacked) {
    const continueButton = submit
      ? <Button type="submit" style={{ width: '100%', ...style }} disabled={isButtonDisabled}>Submit</Button>
      : <Button onClick={handleClick} loading={isLoading ? isLoading : loading} style={{ width: '100%', ...style }} disabled={isButtonDisabled}>{continueText || 'Continue'}</Button>;

    return (
      <Stack gap={4} className={`mt-2 ${className ?? ''}`}>
        {continueButton}
        {!continueOnly && (customBackBtn || (isFirstStep()
          ? <Button variant="outline-primary" style={{ width: '100%', ...style }} href="/" disabled={isButtonDisabled}>Cancel</Button>
          : <Button variant="outline-primary" style={{ width: '100%', ...style }} onClick={previousStep} disabled={isButtonDisabled}>Back</Button>))}
      </Stack>
    );
  }

  if (continueOnly) {
    return (
      <Stack>
        <Button
          onClick={handleClick}
          loading={isLoading ? isLoading : loading}
          style={{ width: '100%', maxWidth: '382px', ...style }}
          className={`mx-auto ${className}`}
          disabled={isButtonDisabled}
        >
          {continueText || 'Continue'}
        </Button>
      </Stack>
    );
  }
  return (
    <Row xs={1} md={2} className="g-4">
      <Col>
        { customBackBtn || ( isFirstStep()
            ? <Button variant="outline-primary" style={{ width: '100%', ...style}} href="/" disabled={isButtonDisabled}>Cancel</Button>
            : <Button variant="outline-primary" style={{ width: '100%', ...style}} onClick={previousStep} disabled={isButtonDisabled}>Back</Button>
          )
        }
      </Col>
      <Col>
      { submit
          ? <Button type="submit" style={{ width: '100%', ...style}} disabled={isButtonDisabled}>Submit</Button>
          : <Button onClick={handleClick} loading={isLoading ? isLoading : loading} style={{ width: '100%', ...style}} disabled={isButtonDisabled}>{continueText || 'Continue'}</Button>
        }
      </Col>
    </Row>
  );
};

export default Navigation;
